import React, { useEffect } from "react";
import { useRouter } from "next/router";
import Cookies from "js-cookie";
import { COOKIES } from "../events/cookies";
import { useMobileAppData } from "../components/context/MobileAppContext";
import { EventTypes } from "../events/mobileApp/mobileAppEvents.types";

const RedirectQuery = ({ query }): any => {
  if (typeof window !== "object") {
    return;
  }
  const router = useRouter();
  const isMobileAppListening = useMobileAppData();

  if (query) {
    useEffect(() => {
      if (isMobileAppListening) {
        window.dispatchEvent(new CustomEvent(EventTypes.SELLER_OPEN));
      } else {
        router.push({
          pathname: "/sell-your-bag",
          query: JSON.parse(query),
        });
      }
    }, [query]);
  } else if (isMobileAppListening) {
    window.dispatchEvent(new CustomEvent(EventTypes.SELLER_OPEN));
  } else {
    router.push(`/sell-your-bag${window.location.search}`);
  }
  return null;
};

const Home = (): React.ReactElement => (
  <div>
    <RedirectQuery query={Cookies.get(COOKIES.QUERY)} />
  </div>
);

export default Home;
